import axios from 'axios';

async function ObtenerServicios(prmFiltro: string = '') {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_servicios"
    
    const datosEnvio = {"usuario": "mpatti", "clave": "all2GetHer_!", "filtro": prmFiltro}
    
    try {
        const response = await axios.post(url, datosEnvio);
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerServicios;